import React, { memo } from 'react'
import { Box } from '@mui/material'

/**
 * Structure-only placeholder for chart areas.
 * Shimmer-from-structure measures and overlays effect.
 */
const ChartAreaShimmer = () => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
            gridArea: 'content',
            bgcolor: 'background.paper',
            p: 2
        }}
    >
        <Box sx={{ height: 32, width: 200, mb: 2, borderRadius: 1 }} />
        <Box sx={{ flex: 1, minHeight: 300, borderRadius: 1 }} />
    </Box>
)

export default memo(ChartAreaShimmer)
